import React from 'react';
import ServiceLayer from '../../services';

// Higher order component used to inject in services to a given component
// How to use:
// Use the HOC to wrap your component
// Example: const WrappedComponentName = withService(ComponentName);
// Then use the WrappedComponentName in place of ComponentName and pass any props as normal
// In your component there should now be a Services prop available

const withService = (BaseComponent) => {
  const WithServiceComponent = React.forwardRef((props, ref) => (
    <BaseComponent ref={ref} Services={ServiceLayer} {...props} />
  ));

  // Set displayName for better debugging
  WithServiceComponent.displayName = `WithService(${BaseComponent.displayName || BaseComponent.name || 'Component'})`;

  return WithServiceComponent;
};

export default withService;
